import React, {useEffect} from 'react'
import styled from 'styled-components'
import MainHeader from '../../components/Header/MainHeader'
import TabButtons from '../../components/TabButtons/TabButtons'
import MediaQuery from 'react-responsive'
import {KIOSK_CONTAINER, MOVE_SEQUENCE} from '../../constants/const'
import ServiceRequestListContainer from './ServiceRequests/ServiceRequestListContainer'
import Department from './Department/Department'
import WorkspaceListContainer from './Workspace/WorkspaceListContainer'
import {
  MOVE_EMPLOYEE_LEAVING,
  MOVE_GROUP,
  MOVE_NEW_HIRE,
  MOVE_SPACE_CHANGE
} from '../../components/kiosk/KioskContent/MoveSequence/MoveSequence'
import Employee from '../Detail/Employee/Employee'
import {fetchBuilding} from '../../utils/buildings'
import MeetingListContainer from './Meetings/MeetingListContainer'
import {useUserState} from '../../context/UserContext'
import {useUIDispatch, useUIState} from '../../context/UIContext'
import {useConfigState, getAvailableActions} from '../../context/ConfigContext'
import {_L, useLocaleState} from '../../context/LocaleContext'
import {useViewFetch} from '../../utils/fetch'

// Display the grid cells if either of the objects in the cell is enabled.
// TODO: Employees is always true? Employee visibility is dependent on the user authorization
const showCellA = ({createrequest, employees = true} = {}) =>
  createrequest || employees
const showCellB = ({meetingspace, workingspace}) => meetingspace || workingspace

const Dashboard = ({serviceRequests, totalNumberOfServiceRequests}) => {
  const localeState = useLocaleState()
  const {user} = useUserState()
  const uiDispatch = useUIDispatch()
  const uiState = useUIState()
  const {detail, activeFloor} = uiState
//  const {show: showDetail} = detail
  let {show: showDetail} = detail
  if (activeFloor.blId && activeFloor.flId) {
	  showDetail = true
  }
  const configState = useConfigState()
  const availableActions = getAvailableActions(configState)

  const {
    meetingspace,
    workingspace,
    createrequest,
    employees
  } = availableActions

  const {data: building} = useViewFetch({
    api: fetchBuilding,
    parameters: {blId: activeFloor.blId},
    initialState: {},
    onChangeOf: [activeFloor]
  })

  const {employee} = user

  useEffect(
    () => {
      if (showDetail) {
        uiDispatch({type: 'setContent', payload: {content: KIOSK_CONTAINER}})
      }
      document.getElementsByTagName("TITLE")[0].innerHTML = "UIUC Facility Access Maps"
    },
    [detail, showDetail, uiDispatch]
  )
/*
  const showMoreRequests = () => {
    uiDispatch({
      type: 'setContent',
      payload: {content: 'SERVICE_MORE_LIST', parentPage: 'DASHBOARD'}
    })
  }

  const showMoreWorkspaceReservations = () =>
    uiDispatch({
      type: 'setContent',
      payload: {content: 'WORKSPACE_MORE_LIST', parentPage: 'DASHBOARD'}
    })

  const showMoreMeetingReservations = () => uiDispatch({
      type: 'setContent',
      payload: {content: 'MEETINGS_MORE_LIST', parentPage: 'DASHBOARD'}
    })


  const onAddEmployee = () => {
    uiDispatch({
      type: 'setContent',
      payload: {content: MOVE_SEQUENCE, props: {type: MOVE_NEW_HIRE, user}}
    })
  }

  const onEmployeeLeaving = employee => {
    uiDispatch({
      type: 'setContent',
      payload: {
        content: MOVE_SEQUENCE,
        props: {type: MOVE_EMPLOYEE_LEAVING, user, employee}
      }
    })
  }

  const onChangeSpace = employee =>
    uiDispatch({
      type: 'setContent',
      payload: {
        content: MOVE_SEQUENCE,
        props: {type: MOVE_SPACE_CHANGE, user, employee}
      }
    })

  const onMoveDepartment = () =>
    uiDispatch({
      type: 'setContent',
      payload: {content: MOVE_SEQUENCE, props: {type: MOVE_GROUP, user: user}}
    })

  const requestSpaceChange = ({employee}) => {
    uiDispatch({
      type: 'setContent',
      payload: {
        content: MOVE_SEQUENCE,
        props: {type: MOVE_SPACE_CHANGE, employee, user}
      }
    })
  }
*/
  const onTabButtonClick = action => {
    // Link to the service catalog
    action = action === 'SERVICE_SEQUENCE' ? 'SERVICE_CATALOG' : action
    uiDispatch({
      type: 'setContent',
      payload: {content: action, parentPage: 'DASHBOARD', props: {building}}
    })
  }

  const onHomeClick = () => {}

  let showA = showCellA({createrequest, employees})
  let showB = showCellB({meetingspace, workingspace})

  const isDepartmentManager = employee.isManager || false

  return (
    <Container>
      <Header role="banner">
        <MainHeader building={building} />
      </Header>
      <MainContent role="main" id="mainApp">
	      <Content>
	          <TabletContent>
	            <GridContent showCellA={showA} showCellB={showB}>
	              <Cell0>
	                <Para1>
	                  Welcome to the new University of Illinois at Urbana-Champaign wayfinding web site. The floorpans in this web site are designed to help our community navigate university buildings. Features include; accessible entries and exits, interior access routes, evacuation assembly areas, restroom and water fountain locations, elevator and stair locations, assistive listening systems, parking, and bus stops.
	                </Para1>
	              </Cell0>
	              <CellA>
	                  <DepartmentEmployees>
	                    <Department
	                      employee={employee}
	                    />
	                  </DepartmentEmployees>
	              </CellA>
	              <CellB>
	              </CellB>
	            </GridContent>	
	          </TabletContent>
	      </Content>
	   </MainContent>
    </Container>
  )
}

export default Dashboard

const Container = styled.div`

  display: grid;
  grid-template-rows: 0px 1fr;
  grid-template-columns: 1fr;
  box-sizing: border-box;

  @media (max-width: 420px) {
    grid-template-rows: 150px 1fr;
  }
`

const Header = styled.header`
  grid-row: 1;
  grid-column: 1 / span 2;
  width: 100%;
  box-sizing: border-box;
`
const MainContent = styled.main`
  display: block;
`

const Content = styled.div`
  background-color: #eff0f4;
  grid-row: 2;
  grid-column: 1;


  @media (max-width: 768px) {
    overflow: auto;
  }
`

const TabletContent = styled.div`
  display: grid;
  grid-template-rows: 110px calc(100vh - 110px);
  grid-template-columns: 1fr 320px;
  box-sizing: border-box;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr 255px;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
  
  @media (max-width: 420px) {
    display: block;
    padding-top: 14px;
    width: 100vw;
  }
`

const GridContent = styled.div.attrs({
  columns: props => (props.showCellB && props.showCellA ? '355px 1fr;' : '1fr;')
})`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  grid-row: 2;
  grid-column: 1 / 3;
  grid-template-rows: 1fr;
  grid-template-columns: ${props => props.columns};
  grid-gap: 24px;
  padding: 14px 24px 0 24px;
  overflow: auto;

  @media (max-width: 1024px) {
    grid-template-rows: auto 1fr;
    grid-template-columns: 1fr;
  }

  @media (max-width: 768px) {
    grid-column: 1;
  }
  
  @media (max-width: 420px) {
    padding: 0 24px 0 24px;
  }
`



const GridCell = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`
const Para1 = styled.p`
  padding-bottom: 15px;
`
const Cell0 = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  grid-row: 1;
  grid-column: 1;
  font-size: 16px;

  @media (max-width: 420px) {
    font-size: 14px;
    text-align: justify;
  }
`

// CellA contains the Employee and Service Request lists
const CellA = styled(GridCell)`
  grid-row: 2;
  grid-column: 1;
  padding-top: 24px;

  @media (max-width: 1024px) {
    flex-direction: row;
    grid-row: 2;
    grid-column: 1;
  }
`

// CellB contains the Meeting and Workspace lists
const CellB = styled(GridCell)`
    grid-row: 1;
    grid-column: 2;

    @media (max-width: 1024px) {
      grid-row: 1;
      grid-column: 1;
`

const DepartmentEmployees = styled.div`
  box-sizing: border-box;
  margin: 0 0 10px 0;

  @media (max-width: 1024px) {
    width: 355px;
    flex: 1;
    padding-right: 10px;
  }
  
  @media (max-width: 420px) {
    width: calc(100vw - 40px);
    padding: 0px;
  }
`

const Requests = styled.div`
  box-sizing: border-box;
  margin-top: 10px;
  @media (max-width: 1024px) {
    width: 100%;
    flex: 1;
    padding-left: 10px;
  }
`

const Meetings = styled.div`
  box-sizing: border-box;
  margin: 10px 0 10px 0;
`

const Workspaces = styled.div`
  box-sizing: border-box;
  margin-top: 10px;
`

const EmployeeContainer = styled.div`
  grid-row: 1 / 3;
  grid-column: 3;
  margin-top: 110px;

  @media (max-width: 768px) {
    grid-row: 1;
    grid-column: 1;
  }
`

const StyledTabButtons = styled.div`
  grid-row: 1;
  grid-column: 1 / 3;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 768px) {
    grid-row: 2;
    grid-column: 1;
  }
`

const StyledMeetingListContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 0 0 10px 0;
`

const Label = styled.div`
  height: 24px;
  font-size: 18px;
  font-weight: bold;
  color: #a4a9b7;
  margin-bottom: 10px;
`